import React, { useEffect } from "react";

import Link from "@atoms/Link";

import { URLS } from "@const/urls";

export default function NotFound() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="pc:col-span-12 pc:grid-cols-12 col-span-8 grid grid-cols-8 gap-1">
      <span className="pc:col-span-2 col-span-8">404 Page Not Found</span>
      <div className="pc:col-span-4 pc:gap-2.5 col-span-8 flex flex-col gap-4 leading-5">
        The page you’re looking for doesn’t exist or is no longer available.
        <Link as="square" href={URLS.HOME} variant="secondary">
          Back to Home
        </Link>
      </div>
    </section>
  );
}
